import { render } from "./SettingProfileView.vue?vue&type=template&id=7ca57bf1&scoped=true&ts=true"
import script from "./SettingProfileView.vue?vue&type=script&lang=ts"
export * from "./SettingProfileView.vue?vue&type=script&lang=ts"

import "./SettingProfileView.vue?vue&type=style&index=0&id=7ca57bf1&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ca57bf1"]])

export default __exports__